var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Answer } from "./../Answer";
export class ProductTypeAnswer extends Answer {
  constructor(_data) {
    super();
    /**
     */
    __publicField(this, "Value");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof ProductTypeAnswer
     */
    __publicField(this, "$type", "V1.CompanyInfo.Questionnaire.Answers.ProductTypeAnswer");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    super.init(_data);
    if (_data) {
      if (_data["Value"] && _data["Value"].constructor === Array) {
        this.Value = [];
        for (let item of _data["Value"]) {
          this.Value.push(ProductTypeAnswerValue[item]);
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    super.toJSON(_data);
    if (this.Value && this.Value.constructor === Array) {
      _data["Value"] = [];
      for (let item of this.Value) {
        _data["Value"].push(ProductTypeAnswerValue[item]);
      }
    }
    return _data;
  }
}
export var ProductTypeAnswerValue = /* @__PURE__ */ ((ProductTypeAnswerValue2) => {
  ProductTypeAnswerValue2["AutomotiveIndustrial"] = "AutomotiveIndustrial";
  ProductTypeAnswerValue2["BeautyHealth"] = "BeautyHealth";
  ProductTypeAnswerValue2["BooksAudio"] = "BooksAudio";
  ProductTypeAnswerValue2["CollectiblesArtStationary"] = "CollectiblesArtStationary";
  ProductTypeAnswerValue2["ElectronicsComputerOffice"] = "ElectronicsComputerOffice";
  ProductTypeAnswerValue2["FashionAccessoriesJewellery"] = "FashionAccessoriesJewellery";
  ProductTypeAnswerValue2["FoodGrocery"] = "FoodGrocery";
  ProductTypeAnswerValue2["HomeGardenTools"] = "HomeGardenTools";
  ProductTypeAnswerValue2["KitchenDining"] = "KitchenDining";
  ProductTypeAnswerValue2["MusicMoviesGames"] = "MusicMoviesGames";
  ProductTypeAnswerValue2["SportingGoodsOutdoors"] = "SportingGoodsOutdoors";
  ProductTypeAnswerValue2["ToysKidsBaby"] = "ToysKidsBaby";
  return ProductTypeAnswerValue2;
})(ProductTypeAnswerValue || {});
